import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useTemplateMessageTranslationProgressQuery } from '@/types/graphql';

const getDateTime = (date: Date) => {
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  return `${date.getFullYear()}/${month}/${day} ${hours}:${minutes}:${seconds}`;
};

const TemplateUploadProgressDialog = () => {
  const templateMessageTranslationProgressResult =
    useTemplateMessageTranslationProgressQuery({
      notifyOnNetworkStatusChange: true,
    });

  const open =
    !templateMessageTranslationProgressResult.data
      ?.templateMessageTranslationProgress.done;

  const { t } = useTranslation('admin');
  const navigate = useNavigate();
  const initDate = new Date();

  useEffect(() => {
    if (open) {
      return templateMessageTranslationProgressResult.startPolling(30000);
    } else {
      return templateMessageTranslationProgressResult.stopPolling();
    }
  }, [open, templateMessageTranslationProgressResult]);

  if (!open || !templateMessageTranslationProgressResult.data) {
    return null;
  }

  return (
    <Dialog open={open} maxWidth="sm">
      <DialogTitle textAlign="right" sx={{ fontWeight: 'normal' }}>
        {`${getDateTime(initDate)} ${t('template.dialog.timePoint')}`}
      </DialogTitle>
      <DialogContent>
        <Stack
          spacing={3}
          alignItems="center"
          sx={{
            py: 5,
            px: 3,
            minWidth: 300,
            minHeight: 200,
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Typography variant="h2">{t('template.dialog.title')}</Typography>
          <Typography variant="h3" sx={{ fontWeight: 'normal' }}>
            {templateMessageTranslationProgressResult.data
              .templateMessageTranslationProgress.processedRecords +
              t('template.dialog.item')}
            /
            {templateMessageTranslationProgressResult.data
              .templateMessageTranslationProgress.totalRecords +
              t('template.dialog.totalItem')}
          </Typography>
          {/* <Typography variant="h3" sx={{ fontWeight: 'normal' }}>
            {t('template.dialog.timeLeft') +
              templateMessageTranslationProgressResult.data
                .templateMessageTranslationProgress.remainingTime +
              t('template.dialog.minute')}
          </Typography> */}
          <Button
            variant="contained"
            color="primary"
            size="large"
            sx={{ mt: 3 }}
            onClick={() => navigate('/admin/room')}
          >
            {t('template.dialog.btnBackToTop')}
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default TemplateUploadProgressDialog;
